import { Component, OnInit } from '@angular/core';
import { CostCenterDto } from 'src/app/models/CostCenterDto';
import { CostCentersService } from 'src/app/services/costcenters.service';

@Component({
  selector: 'app-view-costcenter',
  templateUrl: './view-costcenter.component.html',
  styleUrls: ['./view-costcenter.component.css']
})
export class ViewCostCenterComponent implements OnInit {


  constructor(private costcenterService:CostCentersService ) { }
  
  CostCenters:CostCenterDto[]|undefined;
  ngOnInit(): void {
    this.loadRecords();

  }


 async  loadRecords()
  {
    let  resCostCenters = await this.costcenterService.getCostCenters().toPromise(); 
    this.CostCenters = <CostCenterDto[]> resCostCenters.responseData;

  }
}
